import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { useErrorToast } from '@/core/errors/useErrorToast';
import {
  migrationService,
  type MigrationStartPayload,
} from '../api/migration.service';

export function useMigrationMutations() {
  const qc = useQueryClient();
  const onError = useErrorToast();

  const runMigration = useMutation({
    mutationFn: (payload: MigrationStartPayload) => migrationService.runMigration(payload),
    onSuccess: (result) => {
      void qc.invalidateQueries({ queryKey: queryKeys.migration.all });
      toast.success(
        `${result.jobs.length} job(s) enfileirado(s) · janela ${result.days} dia(s)`
      );
    },
    onError: (e) => onError(e, 'Erro ao iniciar migração de conversas'),
  });

  return { runMigration };
}
